const useStyles = () => {
  return {

    resendModal: {
      borderRadius: '8px',
      width: '500px',
    },
    resendReportContainer: {
      position: 'relative',
      padding: '30px',
    },
    close: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    titleSend: {
      fontSize: '17px',
      fontWeight: '600',
      color: 'c_grey.main',
      marginTop: '5px',
      marginBottom: '5px',
    },
    containerErrorsResend: {
      marginTop: '10px',
      '& ul': {
        listStyle: "none"
      },
      '& .MuiTypography-root': {
        fontSize: '.8rem',
        color: 'c_red.100'
      }
    },
    resendButton: {
      marginTop: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    resendButtonContainer: {
      marginTop: '10px',
      display: 'flex',
      justifyContent: 'end',
      width: '100%',
    },
    cancelBtn: {
      textTransform: 'none',
      fontWeight: 600,
      height: '100%',
    },
  }
}

export { useStyles }
